import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { ComponentIds } from "types/enums/componentIds";
import { Title3Content } from "types/graphql/generated";

interface Props {
  className?: string;
  content: Title3Content;
}

const Title3: VFC<Props> = withErrorBoundary(({ content: { title3Text, title3Description } }) => {
  useAnchor("title3");
  useAnchor(ComponentIds.FiduciaryServices);

  return (
    <StyledTitle className={`title3 Content ${ComponentIds.FiduciaryServices}`}>
      <h2 className="Title3__title Font_40_48_600 md:Font_32_40_600">{title3Text}</h2>
      <Markdown className="Title3__description Color_secondary Font_24_32_450 sm:Font_18_26_450">
        {title3Description}
      </Markdown>
    </StyledTitle>
  );
}, {});

const StyledTitle = styled.section`
  display: flex;
  margin-top: -64px;
  padding-top: 64px;

  .Title3__title {
    width: 320px;
    flex-shrink: 0;
  }

  .Title3__description {
    margin-left: 32px;

    a {
      text-decoration: underline;

      :hover {
        text-decoration: none;
      }

      :active {
        opacity: 0.7;
      }
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    .Title3__title {
      width: 300px;
    }

    .Title3__description {
      margin-left: 64px;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    flex-direction: column;

    .Title3__title,
    .Title3__description {
      width: 100%;
    }

    .Title3__description {
      margin-top: 32px;
      margin-left: 0;
    }
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.md}px`}) {
    .Title3__description {
      margin-top: 16px;
    }
  }
`;

gql`
  fragment Title3Content on ComponentTitleTitle3 {
    title3Text
    title3Description
  }
`;

export { Title3 };
export type { Props as Title3Props };
